
    import {Component, Vue} from 'vue-property-decorator';
    import DatePicker from 'vue2-datepicker';

    @Component({
        components: {
          DatePicker,
        },
        props: {
            placeholder: String,
            type: String,
            name: String,
            label: String,
            value: Date,
            format: {
                type: String,
                default: 'DD.MM.YYYY'
            },
            lang: {
                type: Object,
                default: () => {
                    return {
                        days: ['Ne', 'Po', 'Ut', 'St', 'Št', 'Pi', 'So'],
                        months: ['Jan', 'Feb', 'Mar', 'Apr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec']
                    };
                }
            }
        },
    })
    export default class InputDate extends Vue {
        private value = '';
    }
